import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import * as hotjarTracking from '../tools/hotjar';

import { extractSiteGroupingProps } from '../utils';
import type { TrackingSite } from '../utils';

interface ExperimentViewedArgs {
  userId?: string;
  site?: TrackingSite;
}

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export const onboardingStarted = ({ userId, site }: ExperimentViewedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(userId && { user_id: userId }),
  };

  hotjarTracking.tagRecording('onboarding_started');
  Segment.track('Onboarding Started', data);
};

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export const onboardingEnded = ({ userId, site }: ExperimentViewedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(userId && { user_id: userId }),
  };

  hotjarTracking.tagRecording('onboarding_ended');
  Segment.track('Onboarding Ended', data);
};
